<template>
  <div class="page-content skip-whitespace">
    <div class="page-background background-kontakt" />

    <section class="transparent">
      <div class="card-container container">
        <div class="card">
          <div class="card-header">
            <h3>Telefon</h3>
          </div>
          <div class="card-content">
            <a href="tel:+498924218890">
              +49 (0) 89 - 2421 8890
            </a>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h3>Email</h3>
          </div>
          <div class="card-content">
            <p>
              Nutzen Sie unser
              <a
                v-scroll-to="'#contact-form'"
                class="text-gray-600"
                href="#"
              >
                Kontaktformular >
              </a>
            </p>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h3>Öffnungszeiten</h3>
          </div>
          <div class="card-content">
            <table class="hours-table">
              <tbody>
                <tr>
                  <td>MO</td>
                  <td>-</td>
                  <td>FR</td>
                </tr>
                <tr>
                  <td>10.00</td>
                  <td>-</td>
                  <td>18.00</td>
                </tr>
              </tbody>
            </table>
            <p>Samstags nur nach Vereinbarung</p>
          </div>
        </div>
      </div>

      <div class="card-container container">
        <div class="card">
          <div class="card-header">
            <h3>Anfahrt</h3>
          </div>
          <div class="card-content">
            <p>Marstallstraße 8<br>80539 München</p>
            <p>
              <a
                v-scroll-to="'#location'"
                class="text-gray-600"
                href="#"
              >
                Anfahrtsplan >
              </a>
            </p>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h3>Instagram</h3>
          </div>
          <div class="card-content">
            <p>
              Hier geht es zu unserem <a
                class="text-gray-600"
                href="https://www.instagram.com/gabrieleblachnik"
              >
                Instagram Profil >
              </a>
            </p>
          </div>
        </div>

        <div class="card">
          <div class="card-header">
            <h3>Impressum</h3>
          </div>
          <div class="card-content">
            <p>
              <a
                v-scroll-to="'#impressum'"
                href="#"
                class="text-gray-600"
              >
                Impressum >
              </a>
            </p>
            <p>
              <a
                v-scroll-to="'#datenschutz'"
                href="#"
                class="text-gray-600"
              >
                Datenschutz >
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section
      id="contact-form"
      class="transparent"
    >
      <div class="container">
        <h1 class="text-center font-serif uppercase text-blachnik-gold tracking-wide mb-12">
          Kontaktformular
        </h1>
        <form
          action="https://formspree.io/f/mzbyoeyj"
          method="POST"
        >
          <div class="form-component w-full lg:w-1/2">
            <input
              type="text"
              name="lastName"
              placeholder="Name"
            >
          </div>
          <div class="form-component w-full lg:w-1/2">
            <input
              type="text"
              name="firstName"
              placeholder="Vorname"
            >
          </div>
          <div class="form-component w-full lg:w-1/2">
            <input
              type="email"
              name="email"
              placeholder="E-Mail"
            >
          </div>
          <div class="form-component w-full lg:w-1/2">
            <input
              type="tel"
              name="phone"
              placeholder="Telefon"
            >
          </div>
          <div class="w-full form-component">
            <input
              type="text"
              name="subject"
              placeholder="Betreff"
            >
          </div>
          <div class="w-full form-component">
            <textarea
              rows="10"
              name="message"
              placeholder="Nachricht"
            />
          </div>
          <input
            type="hidden"
            name="_next"
            value="http://www.gabriele-blachnik.de/#/kontakt"
          >
          <div class="w-full form-component text-right">
            <button type="submit">
              Absenden
            </button>
          </div>
        </form>
      </div>
    </section>

    <section
      id="location"
      class="transparent"
    >
      <div class="container">
        <h1 class="text-center font-serif uppercase text-blachnik-gold tracking-wide mb-12">
          Anfahrtsplan
        </h1>
        <img src="../assets/Map.jpg">
      </div>
    </section>

    <section
      id="impressum"
      class="transparent"
    >
      <div class="container impressum">
        <h1 class="text-center font-serif uppercase text-blachnik-gold tracking-wide mb-12">
          Impressum
        </h1>
        <p>
          GABRIELE BLACHNIK GmbH & Co. KG<br>
          Amtsgericht München: HRA 69952, Sitz: München
        </p>

        <p>
          Pers. haftende Gesellschafterin:<br>
          GB Beteiligungs GmbH<br>
          Amtsgericht München: HRB 238532, Sitz: Inning
        </p>

        <p>Geschäftsführerin: Gabriela Peric Kosic</p>

        <p>
          Marstallstrasse 8, 80539 München<br>
          Tel. +49 (0)89 - 2421 8890<br>
          Fax +49 (0)89 - 2916 1848
        </p>

        <p>USt.-Id.-Nr: DE 166 773 773</p>

        <p>
          Fotos: Mick Mazzei / Florian Deventer<br>
          Grafik: Adrienne-Sophie Hoffer<br>
          Realisierung: Max Liebkies
        </p>

        <p>Letzte Aktualisierung: August 2025</p>

        <p>
          Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“).
          Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert
          werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen.
        </p>
      </div>
    </section>

    <section
      id="datenschutz"
      class="transparent"
    >
      <div class="container impressum">
        <h1 class="text-center font-serif uppercase text-blachnik-gold tracking-wide mb-12">
          Datenschutz
        </h1>
        <h2>Datenschutz</h2>
        <p>
          Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.
          Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
        </p>

        <h2>Server-Log-Files</h2>
        <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>

        <ul>
          <li>Browsertyp und Browserversion</li>
          <li>verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>Hostname des zugreifenden Rechners</li>
          <li>Uhrzeit der Serveranfrage</li>
        </ul>

        <p>Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.</p>

        <h2>Recht auf Auskunft, Löschung, Sperrung</h2>
        <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p>

        <h2>Cookies</h2>
        <p>Um den Besuch unserer Website attraktiv zu gestalten und die Nutzung bestimmter Funktionen zu ermöglichen, verwenden wir auf verschiedenen Seiten sogenannte Cookies. Hierbei handelt es sich um kleine Textdateien, die auf Ihrem Endgerät abgelegt werden. Einige der von uns verwendeten Cookies werden nach dem Ende der Browser-Sitzung, also nach Schließen Ihres Browsers, wieder gelöscht (sog. Sitzungs-Cookies). Andere Cookies verbleiben auf Ihrem Endgerät und ermöglichen uns oder unseren Partnerunternehmen, Ihren Browser beim nächsten Besuch wiederzuerkennen (persistente Cookies). Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und einzeln über deren Annahme entscheiden oder die Annahme von Cookies für bestimmte Fälle oder generell ausschließen. Bei der Nichtannahme von Cookies kann die Funktionalität unserer Website eingeschränkt sein.</p>

        <h2>Externe Links</h2>
        <p>Soweit durch Links auf externe Inhalte verwiesen wird, wird keine Haftung übernommen. Die Haftung für solche Inhalte obliegt dem jeweiligen Anbieter.</p>

        <h2>Keine Haftung für Informationen</h2>
        <p>Die Inhalte auf diesen Webseiten sind sorgfältig recherchiert und geprüft. Trotzdem übernimmt der Anbieter keine Haftung für Richtigkeit oder Vollständigkeit der angebotenen Informationen.</p>

        <h2>Externe Schriftarten</h2>
        <p>
          Auf diesen Internetseiten werden externe Schriften von Free Google Font verwendet (Copyright (c) 2018, Claus Eggers Sørensen & Copyright (c) 2018, Andrew Paglinawan). Nähere Informationen finden Sie in den Datenschutzhinweisen von <a href="https://scripts.sil.org/OFL">
            SIL Open Font License, Version 1.1.
          </a>
        </p>

        <p>
          Auf diesen Internetseiten werden externe Schriften von Monotype Imaging Inc. verwendet. Die Einbindung dieser Web Fonts erfolgt durch einen Serveraufruf, in der Regel ein Server in den USA. Hierdurch wird an den Server übermittelt, welche unserer Internetseiten Sie besucht haben. Auch wird die IP-Adresse des Browsers des Endgerätes des Besuchers dieser Internetseiten gespeichert. Nähere Informationen finden Sie in den Datenschutzhinweisen von Monotype, die Sie <a href="www.monotype.com/legal/privacy-policy.">
            hier
          </a> abrufen können.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      title: 'Kontakt',
      meta: [
        {
          'name': 'description',
          'content': 'ATELIER. Marstallstraße 8 80539 München Tel. +49 (0) 89 - 2421 8890. Fax +49 (0) 89 - 2916 1848. E-Mail: info@gabriele-blachnik.de.'
        }
      ]
    }
  }
</script>
